import axios from 'axios'

const SET_SERVER_STATUS = 'SET_SERVER_STATUS'
const SET_CONTINUOUS_LOGS = 'SET_CONTINUOUS_LOGS'

const BASE_URL_getServerStatus = 'api/Logs/AquariusServerStatus/500'
const BASE_URL_getContinuousLogs = 'api/Logs/Aquarius'


function initialState () {
  return {
    ServerStatus: [],
    ContinuousLogs: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getServerStatus({ commit }) {
      try {
        let url = BASE_URL_getServerStatus
        let res = await axios.get(url)
        commit(SET_SERVER_STATUS, res.data)
      }
      catch(error) {
        console.error(error)
      }
    },
    async getContinuousLogs({ commit }, options) {
      try {
        let url = BASE_URL_getContinuousLogs
        let res = await axios.post(url, options.data)
        commit(SET_CONTINUOUS_LOGS, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.ExceptionMessage)
      }
    },    
  },

  mutations: {
    [SET_SERVER_STATUS](state, data) {
      state.ServerStatus = data
    },
    [SET_CONTINUOUS_LOGS](state, data) {
      state.ContinuousLogs = data      
    },    
  },

  getters: {
    ServerStatus: state => state.ServerStatus,
    ContinuousLogs: state => state.ContinuousLogs,
  },
}
